import React, { useEffect, useState } from "react";
import Layout from "../../layout/Main/Layout";
import { Button, Typography } from "@mui/material";
import CustomTable from "../../components/Custom/Table/CustomTable";
import { get, postFiles, put, post, patch } from "../../config/axios";
import Searchbar from "../../components/Custom/SearchBar/Searchbar";
import { deleteAPI } from "../../helper/apiCallHelper";
import DeleteModal from "../../components/Custom/DeleteModal/DeleteModal";
import { toastMessage } from "../../utils/toastMessage";
import AddIcon from "@mui/icons-material/Add";
import FormModal from "../../components/Custom/FormModal/FormModal";
import {
  blogCategoriesFormFields,
  blogCategoriesTableColumns,
} from "../../constants/blogCategoriesPage";
import { useDebouncedValue } from "../../helper/debounce";

const EventCategories = () => {
  const [eventCategories, setEventCategories] = useState([]);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteUser, setDeleteUser] = useState("");
  const [message, setMessage] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);

  const debouncedSearch = useDebouncedValue(search, 500);

  const fetchEventCategories = async (searchValue) => {
    await get(
      `api/dashboard/apputility/getCategory?search=${searchValue}&page=${page}&limit=${10}&type=BLOGS`
    )
      .then((res) => {
        setEventCategories(
          res?.data.map((item) => ({
            ...item,
            action: { edit: true, delete: true },
          }))
        );
        setPageCount(res?.totalPage);
        setTotalData(res?.totalData);
        setPerPage(res?.perPage);
        setCurrentPage(res?.currentPage);
        setMessage(res?.message);
        setLoading(false);
      })
      .catch((err) => {
        console.log("err", err);
        setLoading(true);
      });
  };

  useEffect(() => {
    if (search === "") {
      fetchEventCategories("");
    } else if (debouncedSearch) {
      fetchEventCategories(debouncedSearch);
    }
  }, [search, debouncedSearch, message, page]);

  useEffect(() => {
    // if (!loading && search && eventCategories.length === 0) {
    //   toastMessage("No categories found.", "error");
    // }
    // eslint-disable-next-line
  }, [loading, eventCategories, search]);

  const handleStatus = (row) => {
    console.log("Delete clicked for row34:", row);
  };

  const handleSearch = (searchText) => {
   setSearch(searchText.trim());
    setPage(1);
  };

  const handleDelete = (row) => {
    openModal("delete", row);
  };

  const handleActive = async (id, active) => {
    setLoading(true);
    let response = await put(
      `/api/dashboard/apputility/updateCategory?id=${id}`,
      {
        active: active,
      }
    );

    const categoryTitle = response?.data?.title;
    const message = active
      ? `${categoryTitle} successfully activated.`
      : `${categoryTitle} successfully deactivated.`;

    setLoading(false);
    setMessage(message);
    toastMessage(message, "success");
  };

  const handleDeleteEventCategory = async (row) => {
    try {
      const deletedCategory = await patch(
        `/api/dashboard/apputility/deleteCategory/${row._id}`
      );
      setMessage(deletedCategory?.message);
      toastMessage(deletedCategory?.message, "success");
    } catch (error) {
      console.error(error);
      setMessage("Something went wrong!");
      toastMessage("Something went wrong!", "error");
    }
    setDeleteModalOpen(false);
  };

  const handleCloseDeleteModal = () => {
    setDeleteModalOpen(false);
  };

  const openModal = (type, dataForEdit) => {
    if (type === "add") {
      setIsModalOpen(true);
    } else if (type === "edit") {
      setEditModal(true);
      setEditData(dataForEdit);
    } else if (type === "delete") {
      setDeleteModalOpen(true);
      setDeleteUser(dataForEdit);
    }
  };

  const closeModal = (type) => {
    if (type === "add") {
      setIsModalOpen(false);
      setEditData({});
    } else if (type === "edit") {
      setEditModal(false);
      setEditData({});
    }
  };

  const handleSubmit = async (formData, isEditing, id) => {
    setLoading(true);
    try {
      if (isEditing) {
        let form = new FormData();
        const { ...data } = formData;
        if (formData.asset instanceof File) {
          const validImageTypes = ["image/svg+xml", "image/png", "image/jpeg"];
          if (!validImageTypes.includes(formData.asset.type)) {
            setLoading(false);
            toastMessage("Category Icon (.svg, .png, .jpeg) is required", "error");
            return;
          }
          form.append("file", formData?.asset);
          const res = await postFiles("/api/app/user/uploadImage", form);
          data.asset = res.data.url;
        }
        let response = await put(
          `/api/dashboard/apputility/updateCategory?id=${id}`,
          data
        );
        setMessage(response.message);
        toastMessage(response.message, "success");
      } else {
        const validImageTypes = ["image/svg+xml", "image/png", "image/jpeg"];
        if (!validImageTypes.includes(formData.asset.type)) {
          setLoading(false);
          toastMessage("Category Icon (.svg, .png, .jpeg) is required", "error");
          return;
        }
        formData = {
          ...formData,
          type: "BLOGS",
        };
        let form = new FormData();
        form.append("file", formData?.asset);
        const res = await postFiles("/api/app/user/uploadImage", form);
        const { ...data } = formData;
        data.asset = res.data.url;
        const ret = await post("/api/dashboard/appUtility/addCategory", data);
        setMessage("Successfully added");
        toastMessage(ret.data.message,"success");
        setIsModalOpen(false);
      }
    } catch (err) {
      console.error("Error:", err);
      setMessage("Error while processing the request");
      toastMessage("Error while updating", "error");
    }
    setLoading(false);
  };

  const handleChange = (page) => {
    setPage(page);
  };

  return (
    <>
      <Layout>
        <div style={{ padding: "1rem" }}>
          <Typography variant="h5">Learn Categories</Typography>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ width: "40%" }}>
              <Searchbar
                search={handleSearch}
                placeholder={"Search by category name"}
                debounceTime={1000}
              />
            </div>

            <Button
              onClick={() => openModal("add")}
              variant="outlined"
              startIcon={<AddIcon fontSize="large" />}
              style={{ fontWeight: "bold" }}
            >
              add blog category
            </Button>
          </div>
          <CustomTable
            data={eventCategories}
            columns={blogCategoriesTableColumns}
            handleEdit={(row) => openModal("edit", row)}
            handleDelete={handleDelete}
            handleStatus={handleStatus}
            handleActive={(row, active) => handleActive(row, active)}
            handlePageChange={(page) => handleChange(page)}
            pageNumber={page}
            pageCount={pageCount}
            totalData={totalData}
            perPage={perPage}
            currentPage={currentPage}
            loading={loading}
          />
          {search && eventCategories.length === 0 && !loading && (
            <Typography variant="body1" sx={{ color: 'red', textAlign: 'center', mt: 2 }}>
              No categories found for your search.
            </Typography>
          )}
        </div>
      </Layout>
      <DeleteModal
        open={isDeleteModalOpen}
        onClose={handleCloseDeleteModal}
        onDelete={handleDeleteEventCategory}
        data={deleteUser}
      />
      <FormModal
        accept="image/*"
        isOpen={isModalOpen || editModal}
        onClose={() => closeModal(editModal ? "edit" : "add")}
        onSubmit={handleSubmit}
        fields={blogCategoriesFormFields}
        header={editModal ? "Edit Blog Category" : "Add Blog Category"}
        initialData={editData}
        isEditing={editModal}
      />
    </>
  );
};

export default EventCategories;
